// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import AutosearchController from "./autosearch_controller"
application.register("autosearch", AutosearchController)

import BannerVideoController from "./banner_video_controller"
application.register("banner-video", BannerVideoController)

import DeleteUserModalController from "./delete_user_modal_controller"
application.register("delete-user-modal", DeleteUserModalController)

import LeaveClubMemberModalController from "./leave_club_member_modal_controller"
application.register("leave-club-member-modal", LeaveClubMemberModalController)

import UserMergeSelectController from "./user_merge_select_controller"
application.register("user-merge-select", UserMergeSelectController)

import RecipientAutocompleteController from "./recipient_autocomplete_controller"
application.register("recipient-autocomplete", RecipientAutocompleteController)

import ConversationSubscriptionController from "./conversation_subscription_controller"
application.register("conversation-subscription", ConversationSubscriptionController)

import StyleTreeController from "./style_tree_controller"
application.register("style-tree", StyleTreeController)

import SearchModeController from "./search_mode_controller"
application.register("search-mode", SearchModeController)

import CityAutocompleteController from "./city_autocomplete_controller"
application.register("city-autocomplete", CityAutocompleteController)

import ClubAutocompleteController from "./club_autocomplete_controller"
application.register("club-autocomplete", ClubAutocompleteController)

import RegionAutocompleteController from "./region_autocomplete_controller"
application.register("region-autocomplete", RegionAutocompleteController)

import ClubsSearchController from "./clubs_search_controller"
application.register("clubs-search", ClubsSearchController)

import ClubShowController from "./club_show_controller"
application.register("club-show", ClubShowController)

import PartnerSearchController from "./partner_search_controller"
application.register("partner-search", PartnerSearchController)

import DancerProfileController from "./dancer_profile_controller"
application.register("dancer-profile", DancerProfileController)

import PartnerAnnouncementShowController from "./partner_announcement_show_controller"
application.register("partner-announcement-show", PartnerAnnouncementShowController)

import MarketplaceController from "./marketplace_controller"
application.register("marketplace", MarketplaceController)

import MarketplaceShowController from "./marketplace_show_controller"
application.register("marketplace-show", MarketplaceShowController)

import MarketplaceMineController from "./marketplace_mine_controller"
application.register("marketplace-mine", MarketplaceMineController)

import MarketplaceMediaUploadController from "./marketplace_media_upload_controller"
application.register("marketplace-media-upload", MarketplaceMediaUploadController)

import PartnerAnnouncementMediaUploadController from "./partner_announcement_media_upload_controller"
application.register("partner-announcement-media-upload", PartnerAnnouncementMediaUploadController)

import PartnerAnnouncementFormController from "./partner_announcement_form_controller"
application.register("partner-announcement-form", PartnerAnnouncementFormController)

import ConditionalFieldsController from "./conditional_fields_controller"
application.register("conditional-fields", ConditionalFieldsController)

import ForumCategoryToggleController from "./forum_category_toggle_controller"
application.register("forum-category-toggle", ForumCategoryToggleController)

import ForumCategoriesController from "./forum_categories_controller"
application.register("forum-categories", ForumCategoriesController)

import ForumCategoryController from "./forum_category_controller"
application.register("forum-category", ForumCategoryController)

import ForumTopicController from "./forum_topic_controller"
application.register("forum-topic", ForumTopicController)

import ForumReplyEditorController from "./forum_reply_editor_controller"
application.register("forum-reply-editor", ForumReplyEditorController)

import ForumTopicFormController from "./forum_topic_form_controller"
application.register("forum-topic-form", ForumTopicFormController)

import MobileMenuController from "./mobile_menu_controller"
application.register("mobile-menu", MobileMenuController)

import DropdownController from "./dropdown_controller"
application.register("dropdown", DropdownController)

import NewPostController from "./new_post_controller"
application.register("new-post", NewPostController)

import UserAutocompleteController from "./user_autocomplete_controller"
application.register("user-autocomplete", UserAutocompleteController)

import UserSettingsController from "./user_settings_controller"
application.register("user-settings", UserSettingsController)

import ProfileDanceLevelsController from "./profile_dance_levels_controller"
application.register("profile-dance-levels", ProfileDanceLevelsController)

import TwoFactorController from "./two_factor_controller"
application.register("two-factor", TwoFactorController)

import TwoFactorVerifyController from "./two_factor_verify_controller"
application.register("two-factor-verify", TwoFactorVerifyController)

import AgeCategoryAutocompleteController from "./age_category_autocomplete_controller"
application.register("age-category-autocomplete", AgeCategoryAutocompleteController)

import ProfilesController from "./profiles_controller"
application.register("profiles", ProfilesController)

import ClubsIndexController from "./clubs_index_controller"
application.register("clubs-index", ClubsIndexController)

import MyProfileController from "./my_profile_controller"
application.register("my-profile", MyProfileController)

import MyAnnouncementsController from "./my_announcements_controller"
application.register("my-announcements", MyAnnouncementsController)

import ProfileShowController from "./profile_show_controller"
application.register("profile-show", ProfileShowController)

import ForumSearchController from "./forum_search_controller"
application.register("forum-search", ForumSearchController)

import ForumQuickSearchController from "./forum_quick_search_controller"
application.register("forum-quick-search", ForumQuickSearchController)

import FeeJournalController from "./fee_journal_controller"
application.register("fee-journal", FeeJournalController)

import CoachCalendarController from "./coach_calendar_controller"
application.register("coach-calendar", CoachCalendarController)

import SubstituteToggleController from "./substitute_toggle_controller"
application.register("substitute-toggle", SubstituteToggleController)

import TournamentsController from "./tournaments_controller"
application.register("tournaments", TournamentsController)